import { Radio as AntRadio } from 'antd';
import type { FormField } from '../types';
import type { InputProps } from './types';

type RadioField = FormField & {
  options?: { label: string; value: string }[];
};

export function Radio({ field, value, onChange }: InputProps) {
  const { options } = field as RadioField;
  return (
    <AntRadio.Group
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={field.disabled}
      className="flex flex-col gap-2"
    >
      {options?.map((opt) => (
        <label
          key={opt.value}
          className="flex items-center gap-3 rounded-lg border border-gray-200 p-3 cursor-pointer hover:border-primary transition-colors has-[:checked]:border-primary has-[:checked]:bg-green-50"
        >
          <AntRadio value={opt.value} />
          <span>{opt.label}</span>
        </label>
      ))}
    </AntRadio.Group>
  );
}
